import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient) { }

  searchMenu(criteria: any) {
    return firstValueFrom(this.http.post<MenuSearchResult>('/api/menu/search', criteria));
  }
  searchMenuItem(criteria: any) {
    return firstValueFrom(this.http.post<MenuItemSearchResult>('/api/menu/search/item', criteria));
  }
  searchMenuOption(criteria: any) {
    return firstValueFrom(this.http.post<MenuOptionSearchResult>('/api/menu/search/option', criteria));
  }

  getMenu(id: string) {
    return firstValueFrom(this.http.get<any>(`/api/menu/get/${id}`));
  }
  saveMenu(...menu: any[]) {
    return firstValueFrom(this.http.post<any>('/api/menu/save', menu));
  }
  deleteMenu(menuId: string) {
    return firstValueFrom(this.http.delete<any>(`/api/menu/delete/${menuId}`));
  }
  setMenuIndex(indexes: { [id: string]: number; }) {
    return firstValueFrom(this.http.post('/api/menu/index', indexes));
  }

  getMenuItem(id: string) {
    return firstValueFrom(this.http.get<any>(`/api/menu/get/item/${id}`));
  }
  saveMenuItem(...menuItem: any[]) {
    return firstValueFrom(this.http.post<any>('/api/menu/save/item', menuItem));
  }
  deleteMenuItem(menuItemId: string) {
    return firstValueFrom(this.http.delete<any>(`/api/menu/delete/item/${menuItemId}`));
  }
  setMenuItemIndex(indexes: { [id: string]: number; }) {
    return firstValueFrom(this.http.post(`/api/menu/index/item`, indexes));
  }
  setMenuItemAvailability(indexes: { [id: string]: number; }) {
    return firstValueFrom(this.http.post(`/api/menu/index/availability`, indexes));
  }

  getMenuOption(id: string) {
    return firstValueFrom(this.http.get<any>(`/api/menu/get/option/${id}`));
  }
  saveMenuOption(...menuOption: any[]) {
    return firstValueFrom(this.http.post<any>('/api/menu/save/option', menuOption));
  }
  deleteMenuOption(menuOptionId: string) {
    return firstValueFrom(this.http.delete<any>(`/api/menu/delete/option/${menuOptionId}`));
  }
  setMenuOptionIndex(indexes: { [id: string]: number; }) {
    return firstValueFrom(this.http.post(`/api/menu/index/option`, indexes));
  }

  loadTags(businessId: string) {
    return firstValueFrom(this.http.get<any[]>(`/api/menu/tags/${businessId}`));
  }

  copyBusinessMenu(sourceBusinessId: string, targetBusinessId: string) {
    return firstValueFrom(this.http.post(`/api/menu/copy/${sourceBusinessId}/${targetBusinessId}`, {}));
  }

}

export type MenuSearchResult = { List: any[]; Total: number; };
export type MenuItemSearchResult = { List: any[]; Total: number; };
export type MenuOptionSearchResult = { List: any[]; Total: number; };